import { render } from "./TheSlider.vue?vue&type=template&id=578079b5"
import script from "./TheSlider.vue?vue&type=script&lang=js"
export * from "./TheSlider.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PROJECTS\\2022\\school\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__